export default "__VITE_ASSET__dQWlWHuB__"